import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React, {
  DetailedHTMLProps,
  forwardRef,
  TextareaHTMLAttributes,
} from "react";
import { RefUtil } from "../types/UtilTypes";

interface HTMLTextAreaProps
  extends DetailedHTMLProps<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  error?: boolean;
}

const TextArea = styled.textarea<HTMLTextAreaProps>`
  width: 100%;
  outline: none;
  font-size: 15px;
  padding: 5px;
  color: #2f2f2f;
  border: none;
  resize: none;
  border: 1px solid #dddddd;
  border-radius: 5px;

  :focus {
    box-shadow: 0px 0px 6px #fb972e4d;
    border: 1px solid #fb972e;
  }

  &::placeholder {
    font-size: 14px;
    letter-spacing: 0.16px;
    color: #979797;
  }

  transition: box-shadow 0.3s, border 0.3s;

  ${(props) =>
    props.error &&
    css`
      border: 1px solid #c41700;
      box-shadow: 0px 0px 6px #c417004d;
    `}

  &:disabled {
    color: #2f2f2f;
    background-color: #eceeef;
  }
  background-color: white;
`;

/**
 * @comment use only for email text area
 */
function StyledTextArea(
  props: HTMLTextAreaProps,
  ref: RefUtil<HTMLTextAreaElement>
): JSX.Element {
  const { placeholder } = props;

  return <TextArea ref={ref} placeholder={placeholder} {...props} />;
}

export default forwardRef<HTMLTextAreaElement, HTMLTextAreaProps>(
  StyledTextArea
);
